hostEndingChars